import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
  } from "@mui/material";
  import React from "react";
  
  function DeleteDailog({ open, handleOnClose,title,subtitle }) {
    return (
      <>
        <Dialog open={open} onClose={() => handleOnClose(0)}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContentText sx={{ width: "350px", mt: 1,px:3 }}>
            {subtitle}
          </DialogContentText>
          <DialogContent>
           
          </DialogContent>
  
          <DialogActions>
        
              <Button onClick={()=>handleOnClose(1)} variant="text">
                Yes
              </Button>
            
            <Button onClick={() => handleOnClose(0)} variant="text">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  
  export default DeleteDailog;
  